type SnapshotActionsProps = {
  onPrint: () => void;
  onSave: () => void;
};

function PrinterIcon() {
  return (
    <svg aria-hidden="true" focusable="false" viewBox="0 0 24 24">
      <path d="M7 8V3h10v5M7 17H5a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2M7 14h10v7H7z" />
      <path d="M17.5 11.5h.01" />
    </svg>
  );
}

function DownloadIcon() {
  return (
    <svg aria-hidden="true" focusable="false" viewBox="0 0 24 24">
      <path d="M12 3v12M7.5 10.5 12 15l4.5-4.5M5 21h14" />
    </svg>
  );
}

export function SnapshotActions({ onPrint, onSave }: SnapshotActionsProps) {
  return (
    <div className="snapshot-actions no-print" aria-label="Friction Snapshot actions">
      <button className="snapshot-action-button" type="button" aria-label="Print Friction Snapshot" title="Print" onClick={onPrint}>
        <PrinterIcon />
        <span>Print</span>
      </button>
      <button className="snapshot-action-button" type="button" aria-label="Save Friction Snapshot as PDF" title="Save PDF" onClick={onSave}>
        <DownloadIcon />
        <span>Save PDF</span>
      </button>
    </div>
  );
}
